import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Lesson from '../HEMLesson';
import './mentor.css';

const Crista = () => {

    const { user_id } = useSelector(({ auth }) => auth);
   
    if(!user_id) {
       return <Redirect to='/workspace' />;
     }

  return (
      <Fragment>
        <div className="mentor-container">
            <div className="column-wrapper">
                <div className='row'>
                    <div className='column'>
                        <div className='image-column'>
                            <div className="image-container">
                                <img src="https://haircation.com/wp-content/uploads/2020/01/Crista-scaled.jpg" alt="Ali Gallego" className="mentor-image" />
                            </div>
                        </div>
                    </div>
                    <div className='column'>
                        <div className='mentor-column'>
                            <h1 className="mentor-name">Crista Hatch</h1>    
                            <p className="mentor-about">I was born in Carlsbad, California, was raised in Arizona, and have called both places home throughout my life. 
                            Ever since I was young, I’ve always loved doing hair. As a girl, I remember offering to do my sisters chores so they would let me practice curling and braiding their hair. 
                            While attending high school I was also enrolled in cosmetology school and graduated from both programs in 2012. 
                            I started at Habit Salon at the Gilbert location as an assistant in 2014. After assisting Chrissy for a year, I became a stylist in 2015. 
                            In January of 2020 I moved to the the West Hollywood location. 
                            I love the beach, sun, and being active! My favorite things to do in the salon are extensions, bronde/ sun-kissed color, and effortless short cuts. 
                            </p>  
                            <div className="mentor-live-container">
                                <a href="https://us04web.zoom.us/j/9735040381?pwd=OGFHcXBLVHRRU3R0bkx2UFptNm1JUT09" className="mentor-live">Go To Live Room</a>  
                            </div>
                            <div className="extension-workbook-container">
                                <a href="https://haircation.com/wp-content/uploads/2020/10/New-Habit-Hand-Tied-Extension-Packet.pdf" className="workbook">View Extension Workbook</a>
                            </div>
                            <p className="scroll-hint">👇 Scroll for the course 👇</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Lesson/>
      </Fragment>

  );
}

export default Crista;
